module.exports = __webpack_public_path__ + "img/05.979bc866.png";